
<div class="modal-dialog" style="width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">File Download Failed</h4>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <p>Support has been notified of the problem but it is helpful if you can provide a description of what you were trying to do.</p>
    </div>
    <div class="modal-footer">
      <!--button.btn.btn-outline-secondary(type='button', (click)='support()') Contact Support-->
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
    </div>
  </div>
</div>